var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"opacity","mode":"out-in"}},[(_vm.hasImage && _vm.item.imagem)?_c('img',{class:{ hidden: !_vm.showImage },attrs:{"src":_vm.item.imagem,"alt":_vm.item.titulo},on:{"load":function($event){_vm.showImage = true},"error":function($event){_vm.hasImage = false}}}):_c('div',{staticClass:"no-image"},[_c('NoImage')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }